export class ProductStock {
    stockQuantityAdded: number;
    stockQuantityRemoved: number;
    salePrice: number;
    purchasePrice: number;
    wholesalePrice: number;
    locationId: string;
    locationName: string;
    comment: string;
    createdBy: string;
    updatedBy: string;
    isActive: boolean;    
    totalPayment:number;
    paymentMode:string;
}